import { render, staticRenderFns } from "./social-view-club-feeds-component.vue?vue&type=template&id=04df3c3c&scoped=true&lang=pug"
import script from "./social-view-club-feeds-component.js?vue&type=script&lang=js&external"
export * from "./social-view-club-feeds-component.js?vue&type=script&lang=js&external"
import style0 from "./social-view-club-feeds-component.vue?vue&type=style&index=0&id=04df3c3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04df3c3c",
  null
  
)

export default component.exports